import { useCallback, useEffect, useRef } from "react";

export const useSearchboxBlur = (onBlur: () => void) => {
  const noCloseRef = useRef<HTMLDivElement>(null);

  const handleBlur = useCallback(
    (e: MouseEvent) => {
      const isChild = noCloseRef.current?.contains(e.target as Node);

      if (isChild) return;

      onBlur();
    },
    [onBlur],
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleBlur);

    return () => document.removeEventListener("mousedown", handleBlur);
  }, [handleBlur]);

  return { noCloseRef };
};
